/* tslint:disable */
/* eslint-disable */
/**
 * Survey API
 * API for managing Surveys and Questions.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QuestionDetailDto } from './QuestionDetailDto';
import {
    QuestionDetailDtoFromJSON,
    QuestionDetailDtoFromJSONTyped,
    QuestionDetailDtoToJSON,
    QuestionDetailDtoToJSONTyped,
} from './QuestionDetailDto';

/**
 * 
 * @export
 * @interface QuestionDetailResponse
 */
export interface QuestionDetailResponse {
    /**
     * 
     * @type {QuestionDetailDto}
     * @memberof QuestionDetailResponse
     */
    question?: QuestionDetailDto;
}

/**
 * Check if a given object implements the QuestionDetailResponse interface.
 */
export function instanceOfQuestionDetailResponse(value: object): value is QuestionDetailResponse {
    return true;
}

export function QuestionDetailResponseFromJSON(json: any): QuestionDetailResponse {
    return QuestionDetailResponseFromJSONTyped(json, false);
}

export function QuestionDetailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestionDetailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'question': json['question'] == null ? undefined : QuestionDetailDtoFromJSON(json['question']),
    };
}

export function QuestionDetailResponseToJSON(json: any): QuestionDetailResponse {
    return QuestionDetailResponseToJSONTyped(json, false);
}

export function QuestionDetailResponseToJSONTyped(value?: QuestionDetailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'question': QuestionDetailDtoToJSON(value['question']),
    };
}

